import React, { useState, useEffect } from 'react';
import { getClassNameFactory, getRehydratableName, Button } from '@dcl/ui';
import { ButtonKind, ButtonColor } from '@dcl/ui/dist/elements/Button';
import './index.css';
import { propsToDataAttributes } from '@tr-digital/react-rehydrate';
import { useMobile } from '../../utils/customHooks/useMobile';
import { getBottomMargin } from './helper/utils';
import ArrowIcon from './Icons/Arrowicon';
import { IBackToTop } from './Interface';

export const BackToTop: React.FC<IBackToTop> = (props) => {
  const { desktopBottomMargin = '66px', mobileBottomMargin = '76px' } = props;
  const [isVisible, setIsVisible] = useState(false);
  const buttonTitle = 'Back to top';
  const { isMobile } = useMobile();

  const toggleVisibility = () => {
    if (window.scrollY > 100) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsVisible(window.innerWidth > 100);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const getClassName = getClassNameFactory(BackToTop.displayName);

  return (
    <div
      className={getClassName()}
      data-rehydratable={getRehydratableName(BackToTop.displayName)}
      {...propsToDataAttributes(props)}
    >
      {isVisible && (
        <div
          className={getClassName({
            descendantName: 'button',
          })}
          style={{
            bottom: getBottomMargin(
              isMobile,
              desktopBottomMargin,
              mobileBottomMargin
            ),
          }}
        >
          <Button
            kind={ButtonKind.BUTTON}
            color={ButtonColor.SECONDARY}
            onClick={scrollToTop}
            data-testid="back-to-top-btn"
            aria-label="back to top"
          >
            <div
              className={getClassName({
                descendantName: 'triangle',
              })}
            >
              {ArrowIcon}
            </div>
            <span
              className={getClassName({
                descendantName: 'tooltip',
              })}
            >
              {buttonTitle}
            </span>
          </Button>
        </div>
      )}
    </div>
  );
};

BackToTop.displayName = 'BackToTop';
